import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

type Props = {
  setErrorTimeView: React.Dispatch<React.SetStateAction<any>>;
  setErrorTimeCell: React.Dispatch<React.SetStateAction<any>>;
};

const ErrorTime: React.FC<Props> = ({ setErrorTimeView, setErrorTimeCell }) => {
  const { values } = useFormikContext<any>();

  useEffect(() => {
    setErrorTimeView(false);
    if (values.startVisible !== null && values.endVisible !== null) {
      if (values?.startVisible?.unix() > values?.endVisible?.unix()) {
        return setErrorTimeView(true);
      }
    }
  }, [values.startVisible, values.endVisible]);

  useEffect(() => {
    setErrorTimeCell(false);
    if (values.startBookable !== null && values.endBookableTime !== null) {
      if (values?.startBookable?.unix() > values?.endBookableTime?.unix()) {
        return setErrorTimeCell(true);
      }
    }
  }, [values.startBookable, values.endBookableTime]);

  return null;
};

export default ErrorTime;
